import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const LoginPage = lazy(() =>
  import('./pages/LoginPage').then((module) => ({ default: module.LoginPage })),
);
const ChangePasswordPage = lazy(() =>
  import('./pages/ChangePasswordPage').then((module) => ({ default: module.ChangePasswordPage })),
);

/** Public routes: reachable without a session. */
export const authRoutes: RouteObject[] = [{ path: '/ingresar', element: createElement(LoginPage) }];

/** Authenticated routes: inside AppShell, guarded by the must_change_password block. */
export const authProtectedRoutes: RouteObject[] = [
  {
    path: 'cambiar-contrasena',
    element: createElement(ProtectedRoute),
    children: [{ index: true, element: createElement(ChangePasswordPage) }],
  },
];
